export var NodeName;
(function (NodeName) {
    NodeName["Rectangle"] = "Rectangle";
    NodeName["Ellipse"] = "Ellipse";
    NodeName["Text"] = "Text";
    NodeName["Button"] = "Button";
    NodeName["Image"] = "Image";
    NodeName["Widget"] = "Widget";
    NodeName["Video"] = "Video";
    NodeName["Group"] = "Group";
})(NodeName || (NodeName = {}));
export var NodeKind;
(function (NodeKind) {
    NodeKind["Creative"] = "creative";
    NodeKind["Rectangle"] = "rectangle";
    NodeKind["Text"] = "text";
    NodeKind["Image"] = "image";
    NodeKind["Video"] = "video";
    NodeKind["Group"] = "group";
    NodeKind["Ellipse"] = "ellipse";
    NodeKind["Button"] = "button";
    NodeKind["Widget"] = "widget";
    /** Only set when bfl-widget is in bl. Only applied to `element.type` */
    NodeKind["BannerflowLibraryWidget"] = "bannerflowLibraryWidget";
    /** Only set when bfl-widget is on canvas. Only applied to `element.type`, never on `node.kind` */
    NodeKind["BannerflowLibraryWidgetInstance"] = "bannerflowLibraryWidgetInstance";
})(NodeKind || (NodeKind = {}));
export var NodeKindIcon;
(function (NodeKindIcon) {
    NodeKindIcon["Creative"] = "creative";
    NodeKindIcon["Rectangle"] = "shape-rectangle";
    NodeKindIcon["Text"] = "text";
    NodeKindIcon["Video"] = "video";
    NodeKindIcon["Image"] = "image";
    NodeKindIcon["Group"] = "group";
    NodeKindIcon["AnyElement"] = "any";
    NodeKindIcon["Ellipse"] = "shape-oval";
    NodeKindIcon["Button"] = "button";
    NodeKindIcon["Widget"] = "widget";
    NodeKindIcon["BannerflowLibraryWidget"] = "widget";
    NodeKindIcon["BannerflowLibraryWidgetInstance"] = "widget";
})(NodeKindIcon || (NodeKindIcon = {}));
